function testSpin(element, value) {
  $.ajax({
    url: location.pathname + "/test_play",
    contentType: "application/json",
    type: "get",
    success: function (data) {
      alert(data["message"]);
    },
    error: function (data) {},
  });
}

$(document).ready(function () {
  $(document).on("click", "#test_spin", function () {
    testSpin(this.id, this.value);
  });
});
